import { CostReviewType } from './CostReviewType';

export class NewCostReviewAttributesBase {
    costReviewType!: CostReviewType;
    estimateName: string = '';
    accountName: string = '';
    shipToAddress: string = '';
    sellPrice: number = 0;
    tdc: number = 0;
    gm: number = 0;
    proposalLink: string = '';
    opportunityLink: string = '';
}
